import { AppState } from 'Src/store'
import { createSelector } from 'reselect'

const getIsAvailable = (state: AppState) => state.orders_design.reserveAccount.available
const getIsSelected = (state: AppState) => state.orders_design.reserveAccount.selected
const getIsLocked = (state: AppState) => state.orders_design.reserveAccount.locked

const getIsActive = createSelector(
	getIsSelected,
	getIsLocked,
	(isSelected, isLocked) => isSelected && !isLocked
)

const getIsPossible = createSelector(
	getIsAvailable,
	getIsLocked,
	(isAvailable, isLocked) => isAvailable && !isLocked
)

export const reserveAccountSelectors = {
	getIsAvailable,
	getIsSelected,
	getIsLocked,
	getIsActive,
	getIsPossible,
}
